import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserConstructionMazeGame from 'src/games/ConstructionMazeGame/Main';

interface ConstructionMazeGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class ConstructionMazeGame extends React.Component<ConstructionMazeGameProps> {
    constructor(props: ConstructionMazeGameProps) {
        super(props);
        bindAllOfThis(this, ConstructionMazeGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserConstructionMazeGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default ConstructionMazeGame;



// WEBPACK FOOTER //
// ./src/pages/game/ConstructionMazeGame.tsx